import {
    COMMISSIONS_GET_STATE_BEGIN,
    COMMISSIONS_GET_STATE_SUCCESS,
    COMMISSIONS_GET_STATE_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMISSIONS_GET_STATE_BEGIN:
        return {
          ...state,
          policies: {
            ...state.policies, getCommissionsStatePending: true 
          }
        }
      case COMMISSIONS_GET_STATE_SUCCESS:
        return {
          ...state,
          policies: {
            ...state.policies, 
            getCommissionsStatePending: false,
            getCommissionsStateSuccess:false,
            getCommissionsStateError:null,
            listCommissionsStates:action.data, 
          }
        }
      case COMMISSIONS_GET_STATE_FAILURE:
        return {
          ...state,
          policies: {
            ...state.policies, 
            getCommissionsStatePending: false,
            getCommissionsStateError: action.data 
          }
        }
      default:
        return state
    }
  }